import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import outline from 'helpers/outline';
import {IconCheck} from "../icons";

export type RoundCheckboxProps =
  React.InputHTMLAttributes<HTMLInputElement>;

export const Container = styled.label`
  position: relative;
  cursor: pointer;
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  box-sizing: border-box;
  background-position: center!important;
  background-repeat: no-repeat!important;
  border: 1px solid ${({theme}) => `
    ${transparentize(.9, theme.variables.color)};
  `};
  color: transparent;
  ${transition()};
  
  svg {
    width: 13px;
    height: 9px;
  }
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  
  &:hover + ${Box} {
    color: rgba(255, 255, 255, 0.1);
  }
  
  &:checked + ${Box} {
    border-color: transparent;
    background: ${({theme}) => theme.colors.primary};
    color: white;
  }
  
  &:focus-visible + ${Box} {
    ${outline(8, 2)};
  }
`;

export const CheckerBox = styled.div`
  
`;

/**
 * The round checkbox component
 * @param {RoundCheckboxProps} props
 * @return {React.ReactElement<RoundCheckboxProps>}
 * @constructor
 */
export default function RoundCheckbox(
    props: RoundCheckboxProps,
): React.ReactElement<RoundCheckboxProps> {
  return (
    <Container>
      <Input
        {...props}
        type="checkbox"
      />
      <Box>
        <IconCheck />
      </Box>
    </Container>
  );
}
